module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ki-Lc.edf02b05.png";